var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOptions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "84mm",
    height: "84mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 8400 8400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3843 14l-3592 0 -1 0 -233 0 0 233 0 7895 0 233 233 0 1 0 3592 0 395 0 314 0 3593 0 0 0 234 0 0 -233 0 -6756 -468 0 0 2454 0 81 -80 0 -3279 0 -81 0 0 -81 0 -3278 0 -81 81 0 3279 0 80 0 0 1 468 0 0 -235 0 -233 -234 0 0 0 -3593 0 -314 0 -80 0 -315 0 0 0zm2067 6726l0 400 465 0 0 -400 -465 0zm0 -1541l0 400 465 0 0 -400 -465 0zm1203 738l-1941 0 0 465 1941 0 0 -465zm-3189 -5375l0 3278 0 81 -81 0 -3278 0 -81 0 0 -81 0 -3278 0 -81 81 0 3278 0 81 0 0 81zm1252 1877l1940 0 0 -466 -1940 1 0 465zm-1252 2030l0 3359 0 80 -81 0 -3278 0 -81 0 0 -80 0 -3359 0 -81 81 0 3278 0 0 0 81 0 0 81zm-1614 2088l464 464 330 -330 -464 -464 -57 -57 58 -57 464 -464 -331 -331 -464 464 -57 57 -57 -57 -464 -464 -331 330 464 465 57 57 -57 57 -463 463 330 331 464 -464 57 -57 57 57zm-293 -4038l0 658 465 0 0 -658 0 -80 81 0 657 0 0 -465 -657 0 -81 0 0 -81 0 -657 -465 0 0 657 0 81 -80 0 -658 0 0 465 658 0 80 0 0 80zm2535 1869l3279 0 80 0 0 81 0 3359 0 80 -80 0 -3279 0 -81 0 0 -80 0 -3359 0 -81 81 0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOptions);
export default __webpack_public_path__ + "static/media/options.913a429908762328cee08e4ee0b6ff5e.svg";
export { ForwardRef as ReactComponent };